
export const enum EView {
    entry,
    addGroupNumber,
    department,
    ces,
    export,
    import,
};
